import { useCallback } from 'react';
import usePreAuthAction from '../usePreAuthAction';
import { dataLayerGA } from '../../services/analytics/dataLayerGa';
import { ParentRoute } from '../../utilities/constants/route';

export const useEditorNavigation = () => {
  const { clearPreAuthAction } = usePreAuthAction();

  const handleCreateNewQuestion = useCallback(() => {
    dataLayerGA.newQuestionClick();
    clearPreAuthAction();
    window.location.assign(ParentRoute.HOME.path!);
  }, [clearPreAuthAction]);

  return {
    handleCreateNewQuestion,
  };
};
